export const FETCH_CHATS = 'FETCH_CHATS';
export const FETCH_CHATS_SUCCESS = 'FETCH_CHATS_SUCCESS';
export const ADD_MESSAGE = 'ADD_MESSAGE';
export const ADD_MESSAGE_SUCCESS = 'ADD_MESSAGE_SUCCESS';